<template>
    <div
        class="hts-step-by-step"
        :class="CClass">
        <div
            v-for="(step, index) in steps"
            :key="index"
            class="container">
            <div class="felt">
                <div class="in-step">
                    <slot
                        name="feltInStep"
                        :step="step" />
                </div>
                <div class="in-line">
                    <slot
                        name="feltInLine"
                        :step="step" />
                </div>
            </div>
            <div class="step-item">
                <div v-if="step.stepType === 'vehicle'">
                    <div class="w-8 h-8">
                        <img
                            class="w-full"
                            :src="vehicleImg" >
                    </div>
                </div>
                <div
                    v-else-if="step.stepType === 'task'"
                    class="step-circle-custom w-4 h-4 bg-gray-200 mx-2" />
                <div
                    v-else-if="!step.tasks?.length"
                    class="step-circle-custom w-8 h-8 bg-gray-200" />
                <div
                    v-else
                    class="step-circle-custom w-8 h-8 bg-gray-200 hover:bg-gray-300 font-bold text-main-text flex justify-center items-center"
                    @click="clickStep(step)">
                    <!--
                      <hi-plus-icon

                      class="w-6 h-6 cursor-pointer" />
                    -->
                    <hts-icon-svg
                        v-if="!step.showTask"
                        name="plus"
                        class="w-6 h-6 cursor-pointer !fill-gray-500" />
                    <hts-icon-svg
                        v-else
                        name="minus"
                        class="w-6 h-6 cursor-pointer !fill-gray-500" />
                    <!--
                      <hi-minus-icon

                      class="w-6 h-6 cursor-pointer" />
                    -->
                </div>

                <template v-if="index !== steps.length - 1">
                    <template v-if="steps[index + 1]?.stepType === 'task'">
                        <div
                            class="step-line-custom min-h-[50px]"
                            :class="{
                                'w-[2px] bg-gray-300': step.vehiclePassed,
                                'border-[1px] border-dashed border-gray-300': !step.vehiclePassed
                            }" />
                    </template>
                    <template v-else>
                        <div
                            class="step-line-custom"
                            :class="{
                                'w-[4px] bg-gray-300': step.vehiclePassed,
                                'bg-info-600 !important': step.vehiclePassed && (step.stepType === 'vehicle' || steps[index + 1]?.stepType === 'vehicle'),

                                'border-[2px] border-dashed border-gray-300': !step.vehiclePassed,
                                'border-info-600 !important': !step.vehiclePassed && (step.stepType === 'vehicle' || steps[index + 1]?.stepType === 'vehicle'),

                                'min-h-[50px]': ['vehicle', 'task'].includes(step.stepType) || ['vehicle', 'task'].includes(steps[index + 1]?.stepType),
                                'min-h-[100px]': !(['vehicle', 'task'].includes(step.stepType) || ['vehicle', 'task'].includes(steps[index + 1]?.stepType))
                            }" />
                    </template>
                </template>
            </div>
            <div class="right">
                <div class="in-step">
                    <slot
                        name="rightInStep"
                        :step="step" />
                </div>
                <div class="in-line">
                    <slot
                        name="rightInLine"
                        :step="step" />
                </div>
                <div class="right">
                    <slot
                        name="right"
                        :step="{ ...step, index: index }" />
                </div>
            </div>
        </div>

        <div
            v-if="addEndPoint"
            class="container">
            <div class="felt" />
            <div class="flex items-center flex-col">
                <div class="step-circle-end" />
            </div>
            <div class="right" />
        </div>
    </div>
</template>

<script setup lang="ts">
const vehicleImg = ref('/assets/vehicle.png')

const props = defineProps({
  steps: {
    type: Array<any>,
    required: true
  },
  direction: {
    type: String,
    default: 'vertical'
  },
  addEndPoint: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['clickStep'])

const { steps, direction } = toRefs(props)

const CClass = computed(() => {
  let classData = ''

  const directions: String[] = ['horizontal', 'vertical']

  if (directions.includes(direction.value)) {
    classData += direction.value
  }

  return classData
})

// const journeyStartAtActualValue = computed(() => journey.value.startAtActual || journey.value.startAtEstimate)

const clickStep = (step: any) => {
  emits('clickStep', step)
}
</script>
